import { schema } from 'normalizr';

export const subsidiarySchema = new schema.Entity('clients');
